import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { fetchJson } from "../utils/fetchJson";

const VolumeIssuePage = () => {
  const [articles, setArticles] = useState([]);
  const [allVolumes, setAllVolumes] = useState([]);
  const [showOverview, setShowOverview] = useState(true);
  const [openVolumes, setOpenVolumes] = useState({});
  const location = useLocation();


  const toggleVolume = (volumeId) => {
    setOpenVolumes(prev => ({
      ...prev,
      [volumeId]: !prev[volumeId]
    }));
  };

  const loadIssueData = async (volume, issue) => {
    try {
      const response = await fetchJson(`/json/volume/${issue.data_file}`);
      const articleData = await response.json();
      setArticles(articleData);
      setShowOverview(false);
      window.location.hash = `${volume.id}-${issue.id}`;
    } catch (error) {
      console.error('Error loading articles:', error);
    }
  };

  useEffect(() => {
    // 加载卷期数据
    fetchJson('/json/volumes.json')
      .then(response => response.json())
      .then(data => {
        setAllVolumes(data.volumes);
        
        const hash = location.hash.replace('#', '');
        if (!hash || hash === 'overview') {
          setShowOverview(true);
          setArticles([]);
        } else {
          setShowOverview(false);
          const [volumeId, issueId] = hash.split('-');
          
          // 查找对应的issue数据文件
          const volume = data.volumes.find(v => v.id.toString() === volumeId);
          if (volume) {
            const issue = volume.issues.find(i => i.id.toString() === issueId);
            if (issue) {
              fetchJson(`/json/volume/${issue.data_file}`)
                .then(response => response.json())
                .then(articleData => setArticles(articleData))
                .catch(error => console.error('Error loading articles:', error));
            }
          }
        }
      })
      .catch(error => console.error('Error loading volumes:', error));
  }, [location]);

  return (
    <div className="archives-container">
      {/* 页面头部 */}
      <div className="archives-header">
        <div className="container">
          <h1 className="archives-title">Academic Archive</h1>
          <p className="archives-subtitle">Explore our comprehensive collection of research publications</p>
        </div>
      </div>

      <div className="container">
        {showOverview ? (
          /* 档案概览页面 */
          <div className="archives-content">
            {/* 统计概览 */}
            <div className="archive-overview">
              <div className="overview-stats">
                <div className="stat-card">
                  <div className="stat-icon">V</div>
                  <div className="stat-info">
                    <span className="stat-number">{allVolumes.length}</span>
                    <span className="stat-label">Volumes</span>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">I</div>
                  <div className="stat-info">
                    <span className="stat-number">{allVolumes.reduce((total, vol) => total + vol.issues.length, 0)}</span>
                    <span className="stat-label">Issues</span>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">A</div>
                  <div className="stat-info">
                    <span className="stat-number">{allVolumes.reduce((total, vol) => total + vol.issues.reduce((sum, issue) => sum + (issue.articles_count || 0), 0), 0)}</span>
                    <span className="stat-label">Articles</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 卷期列表 */}
            <div className="volumes-section">
              <h2 className="section-title">Browse by Volume</h2>
              {allVolumes.map(volume => (
                <div key={volume.id} className="volume-item">
                  {/* 卷头部 */}
                  <div 
                    className="volume-header"
                    onClick={() => toggleVolume(volume.id)}
                  >
                    <div className="volume-left">
                      <div className="volume-cover">
                        <img 
                          src={volume.cover_image || '/images/default-cover.jpg'} 
                          alt={`Volume ${volume.id} Cover`}
                          className="cover-image"
                        />
                      </div>
                      <div className="volume-info">
                        <div className="volume-badge">Volume {volume.id}</div>
                        <h3 className="volume-title">{volume.title}</h3>
                        <div className="volume-meta">
                          <span className="volume-year">Year: {volume.year}</span>
                          <span className="volume-count">{volume.issues.length} Issues</span>
                        </div>
                        <p className="volume-description">{volume.description}</p>
                      </div>
                    </div>
                    <div className="volume-toggle">
                      <span className={`toggle-icon ${openVolumes[volume.id] ? 'expanded' : ''}`}>▼</span>
                    </div>
                  </div>
                  {/* 期刊列表 - 可折叠 */}
                  <Collapse in={openVolumes[volume.id]}>
                    <div className="volume-issues">
                      <div className="issues-grid">
                        {volume.issues.map(issue => (
                          <div 
                            key={issue.id} 
                            className="issue-card"
                            onClick={() => loadIssueData(volume, issue)}
                          >
                            <div className="issue-header">
                              <div className="issue-number">#{issue.id}</div>
                              <h4 className="issue-title">{issue.title}</h4>
                            </div>
                            <div className="issue-body">
                              <p className="issue-description">{issue.subtitle}</p>
                              <div className="issue-footer">
                                <span className="issue-date">Date: {issue.publication_date}</span>
                                <span className="issue-articles">{issue.articles_count || 0} Articles</span>
                              </div>
                            </div>
                            <div className="issue-action">
                              <span className="action-text">View Articles</span>
                              <span className="action-arrow">→</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Collapse>
                </div>
              ))}
            </div>
          </div>
      ) : (
          /* 文章列表页面 */
          <div className="articles-page">
            {/* 导航栏 */}
            <div className="articles-nav">
              <button 
                onClick={() => {
                  setShowOverview(true);
                  setArticles([]);
                  window.location.hash = '';
                }}
                className="nav-back-btn"
              >
                <span className="back-icon">←</span>
                <span>Back to Archives</span>
              </button>
              
              {articles.length > 0 && (
                <div className="articles-info">
                  <h2 className="articles-title">Research Articles</h2>
                  <span className="articles-count">
                    {articles.length} {articles.length === 1 ? 'article' : 'articles'} found
                  </span>
                </div>
              )}
            </div>

            {/* 文章列表 */}
            {articles.length > 0 ? (
              <div className="articles-container">
                {articles.map((article, index) => (
                  <article key={index} className="article-item">
                    {/* 文章头部 */}
                    <div className="article-header">
                      <div className="article-index">
                        <span className="index-number">{String(index + 1).padStart(2, '0')}</span>
                      </div>
                      <div className="article-main">
                        <h3 className="article-title">{article.title}</h3>
                        {article.authors && (
                          <div className="article-authors">
                            
                            <span className="authors-text">{article.authors.join(', ')}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* 文章内容 */}
                    <div className="article-content">
                      {article.abstract && (
                        <div className="article-abstract">
                          <h4 className="abstract-title">Abstract</h4>
                          <p className="abstract-text">{article.abstract}</p>
                        </div>
                      )}
                      
                      {/* 文章元信息 */}
                      <div className="article-meta">
                        {article.keywords && (
                          <div className="meta-keywords">
                            <span className="meta-label">Keywords:</span>
                            <div className="keywords-container">
                              {article.keywords.map((keyword, idx) => (
                                <span key={idx} className="keyword-chip">{keyword}</span>
                              ))}
                            </div>
                          </div>
                        )}
                        
                        {article.pages && (
                          <div className="meta-pages">
                            <span className="meta-label">Pages:</span>
                            <span className="pages-info">{article.pages}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="no-articles">
                <div className="no-articles-icon"></div>
                <h3>No Articles Found</h3>
                <p>This issue doesn't contain any articles yet.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default VolumeIssuePage;